import { EntryType } from './EntryTypeEnum';

export const ROOT = Object.freeze({
  tag: EntryType.FOLDER,
  id: '',
  name: 'Folders',
});
